import {assign} from '../ponyfills/assign';
import {_global} from '../utils/global-resolve';
import {reusable} from './convincely';

/** @type {ConsumerConf} */
const localConf = assign({
  consumer: {},
  consumerCaches: {},
}, _global.convincely_conf);

export const conf = reusable('conf', localConf);
